import Cookies from "js-cookie";
import React from "react";
import { useState } from "react";
import useGetAgentName from "../../../hook/useGetAgentName";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useCookiesAgentName from "./useCookiesAgentName";

const RegisterAgent = ({}) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);

  let [searchParams, setSearchParams] = useSearchParams();

  const agentName = useGetAgentName();
  const searchAgent = searchParams.get("ag") || "";

  const cookiesFromAgent = useCookiesAgentName();

  useEffect(() => {
    if (searchAgent) {
      const now = new Date();
      const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);

      if (Cookies.get("ag")) {
        Cookies.remove("ag");
      }
      Cookies.set("ag", searchAgent, { expires: oneHourLater });
    }
  }, [searchAgent]);

  useEffect(() => {
    if (agentName) {
      const { origin, pathname } = window.location;
      const replaceUrl = origin?.replace(`${agentName}.`, "");
      const searchParams = `?ag=${agentName}`;
      const combineUrl = replaceUrl + pathname + searchParams;
      window.location.replace(combineUrl);
    }
  }, [agentName]);

  return (
    cookiesFromAgent && (
      <>
        <label className="text-base text-sm text-base-dark dark:text-base-light-white">
          {i18n_common("registerAgent")}
        </label>
        <input
          value={cookiesFromAgent}
          disabled
          className={`!text-base-light-dark !p-[12px] dark:!text-base-light-white bg-base-light-white dark:!bg-base-light-black border dark:border-base-light-dark rounded-[5px] font-bold py-[15px] !active:border !active: !active:border-main-input-border`}
        />
      </>
    )
  );
};

export default RegisterAgent;
